"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userConfig = void 0;
var color = {
    ORANGE: '#FCB13B',
    BLUE: '#2AB5CD',
    PURPLE: '#7686C5',
    PINK: '#f37cdf',
    GREEN: '#8DC740',
    RED: '#F37C7C',
};
exports.userConfig = {
    color: color,
};
